exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yfzsFTdZFCFDDfLeBbbLw{-ms-flex-negative:0;flex-shrink:0}html[dir] .yfzsFTdZFCFDDfLeBbbLw{background-size:32px}html[dir] .yfzsFTdZFCFDDfLeBbbLw:hover{background-color:\"[theme:neutralLight, default:#edebe9]\"}html[dir] .yfzsFTdZFCFDDfLeBbbLw:active{background-color:\"[theme:neutralTertiaryAlt, default:#c8c6c4]\"}._3icZdv1rtA-N__OI62T7E5{color:\"[theme:neutralSecondary, default:#605e5c]\";line-height:20px;font-size:20px;height:20px}", ""]);
// Exports
exports.locals = {
	"exitButton": "yfzsFTdZFCFDDfLeBbbLw",
	"exitButtonIcon": "_3icZdv1rtA-N__OI62T7E5"
};